"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueViewersApi = void 0;
var _endpointHelpers = require("../util/endpointHelpers");
var _queryClientUtils = require("../util/queryClientUtils");
const IssueViewersApi = exports.IssueViewersApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    get: issueId => api.get("issues/".concat(issueId, "/viewers")).then(response => response.viewers)
  };
}, {
  // There are no mutations in this api, we don't want it to be invalidated by other apis
  invalidateByQueryKeys: () => _queryClientUtils.NO_QUERIES_TO_INVALIDATE
});
//# sourceMappingURL=IssueViewersApi.js.map